import { useState } from "react";
import { FaEnvelope, FaPen, FaInbox, FaSpinner, FaSearch } from "react-icons/fa";
import AccountCard from "./AccountCard";
import FolderList from "./FolderList";

const UNIFIED_ID = "all";

const AccountsSidebar = ({
  accounts,
  activeAccountId,
  connectedAccounts,
  connectingAccounts,
  folders,
  activeFolder,
  loadingUnified,
  onSelectAccount,
  onSelectUnified,
  onToggleConnect,
  onSelectFolder,
  onCompose,
}) => {
  const [accountSearchQuery, setAccountSearchQuery] = useState("");
  const isUnifiedActive = activeAccountId === UNIFIED_ID;

  const filteredAccounts = accountSearchQuery.trim()
    ? accounts.filter((acc) => {
        const q = accountSearchQuery.trim().toLowerCase();
        const nombre = (acc.nombre || "").toLowerCase();
        const imapUser = (acc.imapUser || "").toLowerCase();
        return nombre.includes(q) || imapUser.includes(q);
      })
    : accounts;

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <FaEnvelope className="text-orange-500 text-sm" />
          <h3 className="text-sm font-bold text-gray-800">Correo</h3>
        </div>
        <button
          onClick={onCompose}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-[11px] font-semibold rounded-lg transition-colors"
        >
          <FaPen className="text-[9px]" />
          Redactar
        </button>
      </div>
      <div className="px-4 py-2 border-b border-gray-100">
        <div className="relative">
          <FaSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-[10px]" />
          <input
            type="text"
            placeholder="Buscar cuentas..."
            value={accountSearchQuery}
            onChange={(e) => setAccountSearchQuery(e.target.value)}
            className="w-full pl-7 pr-3 py-1.5 text-[11px] border border-gray-200 rounded-lg focus:outline-none focus:border-orange-400 bg-gray-50"
          />
        </div>
      </div>
      {/* <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <FaEnvelope className="text-orange-500 text-sm" />
          <h3 className="text-sm font-bold text-gray-800">Correo</h3>
        </div>
        <button
          onClick={onCompose}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-[11px] font-semibold rounded-lg transition-colors"
        >
          <FaPen className="text-[9px]" />
          Redactar
        </button>
      </div> */}

      <div className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <div className="px-3 py-2">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Cuentas</span>
        </div>
        <div
          onClick={() => !loadingUnified && accounts.length > 0 && onSelectUnified()}
          className={`flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors border-b border-gray-100
            ${loadingUnified || accounts.length === 0 ? "opacity-60 cursor-not-allowed" : ""}
            ${isUnifiedActive
              ? "bg-orange-50 border-l-[3px] border-l-orange-500"
              : "hover:bg-gray-100 border-l-[3px] border-l-transparent"
            }`}
        >
          <div className="relative">
            <div className="w-9 h-9 rounded-full flex items-center justify-center bg-orange-100 text-orange-600 flex-shrink-0">
              <FaInbox className="text-lg" />
            </div>
            <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white
              ${loadingUnified ? "bg-transparent border-transparent" : "bg-green-500"}`} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-gray-800 truncate">Todos</p>
            <p className="text-[10px] text-gray-500 truncate">
              {loadingUnified ? "Conectando..." : "Todas las cuentas"}
            </p>
          </div>
          {loadingUnified && (
            <FaSpinner className="animate-spin text-orange-500 text-xs flex-shrink-0" />
          )}
        </div>
        {filteredAccounts.map((account) => (
          <div key={account.id}>
            <AccountCard
              account={account}
              isActive={activeAccountId === account.id}
              isConnected={!!connectedAccounts[account.id]}
              isConnecting={!!connectingAccounts[account.id]}
              onSelect={onSelectAccount}
              onToggleConnect={onToggleConnect}
            />
            {activeAccountId === account.id && connectedAccounts[account.id] && (
              <FolderList
                folders={folders}
                activeFolder={activeFolder}
                onSelectFolder={onSelectFolder}
              />
            )}
          </div>
        ))}
        {accounts.length === 0 && (
          <div className="px-4 py-8 text-center">
            <p className="text-xs text-gray-400">No hay cuentas disponibles</p>
          </div>
        )}
        {accounts.length > 0 && filteredAccounts.length === 0 && (
          <div className="px-4 py-8 text-center">
            <p className="text-xs text-gray-400">No hay cuentas que coincidan con la búsqueda</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountsSidebar;
